
export default {
  name: 'App'
}
